import {atom, createStore} from 'jotai';
import {Client} from "@microsoft/microsoft-graph-client";
import {TeamsUserCredential} from "@microsoft/teamsfx";
import {Group, User} from "./services/types.ts";

export const errorAtom = atom<string | undefined | null>(undefined);

export const appIdAtom = atom<string | undefined>(undefined);
export const teamsUserCredentialAtom = atom<TeamsUserCredential | undefined>(undefined);
export const graphClientAtom = atom<Client | undefined>(undefined);

export const selectedTabAtom = atom<"home" | "groups" | "messageSeries" | "activeModules">("home");
export const groupsTabViewAtom = atom<string>('list')
export const selectedAudienceAtom = atom<Group | null>(null)

export const teamsGroupStepAtom = atom<string>('selectTeams')
export const teamsGroupLoadingAtom = atom<boolean>(false)
export const teamsGroupUsersAtom = atom<User[]>([])

export const store = createStore();
